import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { PurchaseAdviceAddEditObject, OrderItemAddEditObject, OrderItemAddEditObjectForUnit } from '../purchaseAdvice'
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import groupService from '../../Group/services';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { TableContentPurchase } from '../../Common/Table/tableContent';
import MenuItem from '@material-ui/core/MenuItem';
import { CommonDecryptParam } from '../../../../utils/CommonParams';

import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import Autocomplete from '@material-ui/lab/Autocomplete';

const screenCode = 'PURCHASEORDER';

export function PurchaseAdviceAddEdit(props) {

    let history = useHistory();
    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const tableHeaderStyle = {
        color: "#263238",
        textTransform: "uppercase",
        fontSize: "12px",
        fontWeight: "bold"
    }
    const subTableHeaders = {
        textTransform: "uppercase",
        fontSize: "12px"
    }

    const [title, setTitle] = useState("Add Order")
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionTypes, setCollectionTypes] = useState([]);
    const [buyers, setBuyers] = useState([]);
    const [orderItemArray, setOrderItemArray] = useState([]);
    const [purchaseAdvice, setPurchaseAdvice] = useState({
        groupID: '0',
        operationEntityID: '0',
        buyerID: '0',
        invoiceDate: new Date().toISOString().split('T')[0],
        dueDate: new Date().toISOString().split('T')[0],
        statusTypeID: 0,
        country: ""

    });
    const [purchaseOrderItem, setPurchaseOrderItem] = useState({
        collectionTypeID: '0',
        measuringUnit: '0',
        price: '',
        packageWeight: '',
        totalPackagesStore: '',
        totalPackagesExport: '',
        itemQuantity: '',
        maxAmount: '',
        aspNetUserId: '0'
    });
    const [errors, setErrors] = useState({});
    const [orderItemErrors, setOrderItemErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [itemDetails, setItemDetails] = useState([]);
    const [orderDetails, setOrderDetails] = useState([]);
    const [users, setUsers] = useState([]);

    const schema = Joi.object(PurchaseAdviceAddEditObject).options({ allowUnknown: true });
    const orderItemsschema = Joi.object(OrderItemAddEditObject).options({ allowUnknown: true });
    const orderItemsschemaForUnit = Joi.object(OrderItemAddEditObjectForUnit).options({ allowUnknown: true });

    const [randomValue, setRandomValue] = useState(0);
    const contentRowNames = ["collectionTypeName", "userName", "price", "packageWeight",
        "measuringUnit", "totalPackagesStore", "totalPackagesExport", "itemQuantity", "maxAmount"];
    const [isEditScreen, setIsEditScreen] = useState(false);
    const [supplierOrderItemCount, setSupplierOrderItemCount] = useState(0);
    const [isSaveButtonDisabled, setSaveButtonDisabled] = useState(false);

    const encriptedTest = props.match.params["id"];
    const id = (encriptedTest !== undefined) ? CommonDecryptParam(props.match.params["id"]) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getCompanies()
        );
    }, [purchaseAdvice.groupID]);

    useEffect(() => {
        trackPromise(
            getItems(),
            getBuyers(),
            getUsers()
        );
    }, [purchaseAdvice.operationEntityID]);

    useEffect(() => {
        if (parseFloat(purchaseOrderItem.totalPackagesStore) >= parseFloat(purchaseOrderItem.totalPackagesExport)
            && parseFloat(purchaseOrderItem.totalPackagesStore) !== 0 && parseFloat(purchaseOrderItem.totalPackagesExport) !== 0) {
            setOrderItemErrors({
                ...orderItemErrors,
                orderItem: "Max Total Packages value is less than total package"
            });
        } else {
            const error = { ...orderItemErrors }
            delete error["orderItem"]
            setOrderItemErrors(error);
        }
    }, [purchaseOrderItem])

    useEffect(() => {
        if (messageModel.hidden === false && messageModel.type !== "Success") {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 2000);
        }
    }, [messageModel])
    useEffect(() => {
        setPurchaseOrderItem({
            ...purchaseOrderItem,
            itemQuantity: '',
            maxAmount: '',
            packageWeight: '',
            totalPackagesStore: '',
            totalPackagesExport: ''
        })
    }, [purchaseOrderItem.measuringUnit]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITPURCHASEORDERS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setEditScreenData();
            setIsEditScreen(true);
        } else {
            setTitle("Add Order");
            var token = tokenService.getUserDetailsFromToken();
            setPurchaseAdvice({
                ...purchaseAdvice,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getAllGroups()
        )
    }

    async function getAllGroups() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups)
    }

    async function getCompanies() {
        const companies = await services.getMultiCropsByGroupID(purchaseAdvice.groupID);
        setOperationEntity(companies);
    }

    async function getItems() {
        const items = await services.GetCollectionTypeByOperationEntityForSearchDropDown(purchaseAdvice.operationEntityID);
        setCollectionTypes(items);
    }

    async function getBuyers() {
        const buyerRes = await services.GetBuyerByOperationEntity(purchaseAdvice.operationEntityID);
        setBuyers(buyerRes);
    }

    async function getUsers() {
        const userRes = await services.getUsers(purchaseAdvice);
        setUsers(userRes);
    }

    async function setEditScreenData() {

        var result = await services.getSelectedOrderDetails(id);
        var supplierOrderItemsArray = result.supplierOrderItems;

        if (result.order.statusTypeID === 1 || result.order.statusTypeID === 0) {
            setTitle("Edit Order");
            setButtonName("Update");
        } else {
            setTitle("View Order");
            setExpandTableData();
        }

        setPurchaseAdvice({
            ...purchaseAdvice,
            groupID: result.order.groupID,
            operationEntityID: result.order.operationEntityID,
            buyerID: result.order.buyerID,
            invoiceDate: result.order.invoiceDate.split('T')[0],
            dueDate: result.order.dueDate.split('T')[0],
            orderID: result.order.orderID,
            statusTypeID: result.order.statusTypeID
        });

        const userRes = await services.getUsers({ groupID: result.order.groupID, operationEntityID: result.order.operationEntityID });

        result.orderItems.forEach((x, i) => {

            var hasSupplieritems = supplierOrderItemsArray.filter(y => y.orderItemID === x.orderItemID);

            if (hasSupplieritems.length > 0) {
                x.isButtonEnabled = 0;
            } else {
                x.isButtonEnabled = 1;
            }

            x.userName = userRes[x.aspNetUserId];
            x.state = 0;
            x.index = i;
        });

        setOrderItemArray(result.orderItems);
    }

    function handleChange(e) {
        const target = e.target
        const value = target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, PurchaseAdviceAddEditObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setPurchaseAdvice({
            ...purchaseAdvice,
            [e.target.name]: value
        })
        setErrors(error)
    }

    function handleDateChange(e) {

        if (e.target.value < new Date().toISOString().split('T')[0]) {
            setErrors({
                ...errors,
                dueDate: "Due can not be Early Date than Invoice Date"
            });
            return;

        } else {
            const error = { ...errors }
            delete error["dueDate"]
            setErrors(error);
            handleChange(e);
        }
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null)
            return;

        var nameV = "collectionTypeID";
        var valueV = data["collectionTypeID"];

        const error = { ...orderItemErrors }
        var errorMessage = "";
        if (purchaseOrderItem.measuringUnit === "1") {
            errorMessage = validateProperty({ name: nameV, value: valueV }, OrderItemAddEditObject)
        } else {
            errorMessage = validateProperty({ name: nameV, value: valueV }, OrderItemAddEditObjectForUnit)
        }
        errorMessage ? error[nameV] = errorMessage : delete error[nameV];

        setPurchaseOrderItem({
            ...purchaseOrderItem,
            collectionTypeID: valueV.toString()
        });

        setOrderItemErrors(error);
    }
    async function bindBuyer(value){
        setPurchaseAdvice(
            {
                ...purchaseAdvice,
                buyerID : value.buyerID
            }
        );
    }


    function handlePurchaseItemChange(e) {
        const target = e.target;
        const value = target.value;

        const error = { ...orderItemErrors }
        var errorMessage = "";
        errorMessage = validateProperty(target, OrderItemAddEditObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setPurchaseOrderItem({
            ...purchaseOrderItem,
            [e.target.name]: value
        })
        setOrderItemErrors(error);
    }

    async function handleSave(e) {
        setSaveButtonDisabled(true);
        e.preventDefault()

        const errorMessages = validate(schema, purchaseAdvice);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var orderItem = orderItemArray.filter(x => x.state === 2);

        if (orderItem.length >= orderItemArray.length) {
            setErrors({
                ...errors,
                orderItem: "Please add at least one Item."
            });
            return;
        }

        if (!edit) {
            const response = await services.saveOrder(purchaseAdvice, orderItemArray);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: "Order number is " + response.message });

            clearState();
        } else {
            const response = await services.editOrder(purchaseAdvice, orderItemArray);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        }
        setSaveButtonDisabled(false);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/PurchaseAdvice' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setOrderItemArray([]);
        setPurchaseAdvice({
            ...purchaseAdvice,
            buyerID: '0',
            invoiceDate: new Date().toISOString().split('T')[0],
            dueDate: new Date().toISOString().split('T')[0],
            collectionTypeID: '0',
            itemQuantity: '',
            measuringUnit: ''
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function handleAddItem() {
        var selectedItem = collectionTypes.find((x, index) => x.collectionTypeID === parseInt(purchaseOrderItem.collectionTypeID));

        var orderItemArrayCopy = [...orderItemArray];

        if (orderItemErrors.orderItem) {
            return;
        }

        setSupplierOrderItemCount(supplierOrderItemCount + 1)

        const newOrderItem = {
            id: supplierOrderItemCount + 1,
            orderItemID: 0,
            collectionTypeName: selectedItem.collectionTypeName,
            price: parseFloat(purchaseOrderItem.price),
            measuringUnit: parseInt(purchaseOrderItem.measuringUnit),
            collectionTypeID: parseInt(purchaseOrderItem.collectionTypeID),
            itemQuantity: parseFloat(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore),
            state: 1,
            packageWeight: parseFloat(purchaseOrderItem.packageWeight),
            totalPackagesStore: parseInt(purchaseOrderItem.totalPackagesStore),
            totalPackagesExport: parseInt(purchaseOrderItem.totalPackagesExport),
            maxAmount: parseFloat(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport),
            aspNetUserId: parseInt(purchaseOrderItem.aspNetUserId),
            userName: users[purchaseOrderItem.aspNetUserId]
        }

        setOrderItemArray([...orderItemArray, newOrderItem]);
        setRandomValue(Math.random());
        setPurchaseOrderItem({
            ...purchaseOrderItem,
            collectionTypeID: '0',
            measuringUnit: '0',
            price: '',
            packageWeight: '',
            totalPackagesStore: '',
            totalPackagesExport: '',
            itemQuantity: '',
            maxAmount: '',
            aspNetUserId: '0'
        })
    }

    function handleItemRemoveClick(data) {
        var allorderItems = [...orderItemArray];

        var selectedItems = allorderItems.filter(x => (x.id === data.id));
        var indexOfSelectedItems = 0;

        allorderItems.forEach((x, i) => {
            if (x.id === data.id) {
                indexOfSelectedItems = i;
            }
        });

        var updatedArray = allorderItems.filter(x => (x.id !== data.id));

        if (selectedItems[0].state === 0) {
            allorderItems[indexOfSelectedItems].state = 2;
            setOrderItemArray(allorderItems);
        } else {
            setOrderItemArray(updatedArray);
        }
    }

    async function onRemoveClick() {
        const response = await services.removeOrder(id);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        afterSuccessfulyChanged(response.statusCode);
    }

    function createData(orderItemID, collectionTypeName, collectionTypeID, itemQuantity,
        measuringUnit, state, supplierItems) {
        return {
            orderItemID,
            collectionTypeName,
            collectionTypeID,
            itemQuantity,
            measuringUnit,
            state,
            supplierItems
        };
    }

    async function setExpandTableData() {
        var result = await services.getSelectedOrderDetails(id);
        setOrderDetails(result.order);

        var items = [];

        result.orderItems.forEach(x => {
            var supplierItems = [];

            result.supplierOrderItems.forEach(r => {
                if (r.orderItemID === x.orderItemID) {
                    supplierItems.push({
                        supplierOrderItemsID: r.supplierOrderItemsID,
                        orderItemID: r.orderItemID,
                        customerID: r.customerID,
                        supplierName: r.firstName,
                        unitPrice: r.unitPrice,
                        totalPrice: r.totalPrice,
                        supplingQauntity: r.supplingQauntity,
                        lastUnitPrice: r.lastUnitPrice,
                        statusType: r.statusTypeID
                    })
                }
            })

            items.push(
                createData(
                    x.orderItemID,
                    x.collectionTypeName,
                    x.collectionTypeID,
                    x.itemQuantity,
                    x.measuringUnit,
                    x.state,
                    supplierItems
                )
            );

        });

        setItemDetails(items);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/PurchaseAdvice"
                        />
                        <hr />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Group *</InputLabel>
                                        <Select fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled || isEditScreen}
                                            value={purchaseAdvice.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Company *</InputLabel>
                                        <Select fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled || isEditScreen}
                                            value={purchaseAdvice.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Company--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4 pt-2">
                                        <Autocomplete
                                                    id="buyerID"
                                                    options={buyers}
                                                    key={randomValue}
                                                    getOptionLabel={(option) => option.buyerName+ " - "+ option.buyerCode}
                                                    onChange={(e, buyers) => bindBuyer(buyers)}
                                                    renderInput={(params) => <TextField {...params} label="Buyer *" variant="outlined" size="small" />}
                                                />
                                        {errors["buyerID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["buyerID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Invoice Date *"
                                            name="invoiceDate"
                                            id="invoiceDate"
                                            value={purchaseAdvice.invoiceDate}
                                            disabled={true}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["invoiceDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["invoiceDate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Due Date *"
                                            name="dueDate"
                                            id="dueDate"
                                            value={purchaseAdvice.dueDate}
                                            disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleDateChange(e)} />
                                        {errors["dueDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["dueDate"]}</FormHelperText>}
                                    </div>
                                </div>
                                {
                                    <div>
                                        <div className="card-title pt-3"><p style={{ fontSize: "16px" }}>Item Details</p></div>
                                        <div className="form-group row">
                                            <div className="col-md pt-3">
                                                <Autocomplete
                                                    id="collectionTypeID"
                                                    options={collectionTypes}
                                                    key={randomValue}
                                                    getOptionLabel={(option) => option.collectionTypeName.toString()}
                                                    onChange={(e, value) => handleSearchDropdownChange(value)}
                                                    renderInput={(params) => <TextField {...params} label="Product *" variant="outlined" size="small" />}
                                                />
                                                {orderItemErrors["collectionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["collectionTypeID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md">
                                                <InputLabel shrink id="aspNetUserId">Purchasing Manager *</InputLabel>
                                                <Select fullWidth
                                                    id="aspNetUserId"
                                                    name="aspNetUserId"
                                                    value={purchaseOrderItem.aspNetUserId}
                                                    onChange={(e) => handlePurchaseItemChange(e)}>
                                                    <MenuItem value="0">--Select Purchasing Manager--</MenuItem>
                                                    {generateDropDownMenu(users)}
                                                </Select>
                                                {errors["aspNetUserId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["aspNetUserId"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pt-1">
                                                <TextField fullWidth label="Selling Price *"
                                                    name="price"
                                                    id="price"
                                                    value={purchaseOrderItem.price}
                                                    disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                    type="text"
                                                    onChange={(e) => handlePurchaseItemChange(e)}
                                                />
                                                {orderItemErrors["price"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["price"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md">
                                                <InputLabel shrink id="measuringUnit">Measuring Unit *</InputLabel>
                                                <Select fullWidth
                                                    id="measuringUnit"
                                                    name="measuringUnit"
                                                    disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                    value={purchaseOrderItem.measuringUnit}
                                                    onChange={(e) => handlePurchaseItemChange(e)}>
                                                    <MenuItem value="0">--Select Measuring Unit--</MenuItem>
                                                    <MenuItem value="1">Kg</MenuItem>
                                                    <MenuItem value="2">Unit</MenuItem>
                                                </Select>
                                                {orderItemErrors["measuringUnit"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["measuringUnit"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        {purchaseOrderItem.measuringUnit === "1" ?
                                            <div className="form-group row">
                                                <div className="col-md pt-1">
                                                    <TextField fullWidth label="Package Weight *"
                                                        name="packageWeight"
                                                        id="packageWeight"
                                                        value={purchaseOrderItem.packageWeight}
                                                        disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                        type="text"
                                                        onChange={(e) => handlePurchaseItemChange(e)}
                                                    />
                                                    {orderItemErrors["packageWeight"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["packageWeight"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md pt-1">
                                                    <TextField fullWidth label="Total Packages (Store) *"
                                                        name="totalPackagesStore"
                                                        id="totalPackagesStore"
                                                        value={purchaseOrderItem.totalPackagesStore}
                                                        disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                        type="text"
                                                        onChange={(e) => handlePurchaseItemChange(e)}
                                                    />
                                                    {orderItemErrors["totalPackagesStore"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesStore"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md pt-1">
                                                    <TextField fullWidth label="Max Total Packages (Export) *"
                                                        name="totalPackagesExport"
                                                        id="totalPackagesExport"
                                                        value={purchaseOrderItem.totalPackagesExport}
                                                        disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                        type="text"
                                                        onChange={(e) => handlePurchaseItemChange(e)}
                                                    />
                                                    {orderItemErrors["totalPackagesExport"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesExport"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md-3 pt-4">
                                                    <div className="d-inline">Exact Amount(Kg) : </div> <div className="d-inline" style={{ fontSize: '18px' }}>{(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore).toFixed(2)}</div>
                                                </div>
                                                <div className="col-md-3 pt-4">
                                                    <div className="d-inline">Max Amount(Kg) : </div><div className="d-inline" style={{ fontSize: '18px' }}>{(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport).toFixed(2)}</div>
                                                </div>
                                            </div>
                                            :
                                            (purchaseOrderItem.measuringUnit === "2" ?
                                                <div className="form-group row">
                                                    <div className="col-md pt-1">
                                                        <TextField fullWidth label="Package Weight *"
                                                            name="packageWeight"
                                                            id="packageWeight"
                                                            value={purchaseOrderItem.packageWeight}
                                                            disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                            type="text"
                                                            onChange={(e) => handlePurchaseItemChange(e)}
                                                        />
                                                        {orderItemErrors["packageWeight"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["packageWeight"]}</FormHelperText>}
                                                    </div>
                                                    <div className="col-md pt-1">
                                                        <TextField fullWidth label="Total Packages (Store) *"
                                                            name="totalPackagesStore"
                                                            id="totalPackagesStore"
                                                            value={purchaseOrderItem.totalPackagesStore}
                                                            disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                            type="text"
                                                            onChange={(e) => handlePurchaseItemChange(e)}
                                                        />
                                                        {orderItemErrors["totalPackagesStore"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesStore"]}</FormHelperText>}
                                                    </div>
                                                    <div className="col-md pt-1">
                                                        <TextField fullWidth label="Max Total Packages (Export) *"
                                                            name="totalPackagesExport"
                                                            id="totalPackagesExport"
                                                            value={purchaseOrderItem.totalPackagesExport}
                                                            disabled={purchaseAdvice.statusTypeID !== 1 && edit}
                                                            type="text"
                                                            onChange={(e) => handlePurchaseItemChange(e)}
                                                        />
                                                        {orderItemErrors["totalPackagesExport"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesExport"]}</FormHelperText>}
                                                    </div>
                                                    <div className="col-md-3 pt-4">
                                                        <div className="d-inline">Exact Amount(Kg) : </div> <div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore}</div>
                                                    </div>
                                                    <div className="col-md-3 pt-4">
                                                        <div className="d-inline">Max Amount(Kg) : </div><div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport}</div>
                                                    </div>
                                                </div>
                                                : null)
                                        }
                                        <div className="form-group row">
                                            <div className="col">
                                                <input
                                                    type="button"
                                                    className="btn btn-primary pull-right"
                                                    disabled={(purchaseOrderItem.measuringUnit === "0" ? true :
                                                        (validate(orderItemsschema, purchaseOrderItem))) || (purchaseAdvice.statusTypeID !== 1 && edit)}
                                                    onClick={handleAddItem}
                                                    value="Add"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            {orderItemErrors["orderItem"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["orderItem"]}</FormHelperText>}
                                        </div>
                                        {
                                            (orderItemArray.length > 0) ?
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="table-responsive row-top-gap">
                                                            <table className="display dataTable no-footer">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Item Name</th>
                                                                        <th>Purchase Manager</th>
                                                                        <th>Price</th>
                                                                        <th>Package Weight</th>
                                                                        <th>Measuring Unit</th>
                                                                        <th>Total Packages (Store)</th>
                                                                        <th>Max Total Packages (Export)</th>
                                                                        <th>Exact Amount (Kg)</th>
                                                                        <th>Max Amount (Kg)</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <TableContentPurchase
                                                                        data={orderItemArray.filter(x => parseInt(x.state) !== 2)}
                                                                        contentRowNames={contentRowNames}
                                                                        handleClick={handleItemRemoveClick}
                                                                        purchaseValue={purchaseAdvice.statusTypeID}
                                                                    />
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null
                                        }
                                    </div>
                                }
                            </div>
                            <div className="card-footer">
                                {(purchaseAdvice.statusTypeID === 1 || purchaseAdvice.statusTypeID === 0) ? <div>
                                    <input
                                        disabled={validate(schema, purchaseAdvice) || !(orderItemArray.length > 0) || errors.dueDate || isSaveButtonDisabled}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        disabled={edit}
                                        onClick={onCancelClick}
                                    />
                                </div> : null}
                                {purchaseAdvice.statusTypeID === 1 && edit ?
                                    <input
                                        type="button"
                                        className="btn btn-warning"
                                        value="Remove"
                                        onClick={onRemoveClick}
                                    /> : null}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}